import MembersOnlyHomepage from "./MembersOnlyHomepage";
import RegularHomepage from "./RegularHomepage";


export default function HomepageContent({
	membersOnly = false,
	animationClass = '',
	animationData = {},
}) {
	const Component = membersOnly ? MembersOnlyHomepage : RegularHomepage;

	return (
		<Component
			animationClass={animationClass}
			animationData={animationData}
		/>
	);
}